<template>
  <a-card>
    <a-form-model :model="form.data" :rules="form.rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
      <a-form-model-item label="题目类型" prop="questionType">
        <a-select v-model="form.data.questionType" @change="questionTypeChange" placeholder="请选择">
          <a-select-option :value="item.value" v-for="item in questionTypeList" :key="item.title">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="题目名称" prop="name" required>
        <div class="wang-editor" ref="wangEditorBox"></div>
        <a-button @click="fullQuestionEdit.visible = true" type="primary" v-if="form.data.questionType == 7">插入内容 </a-button>
      </a-form-model-item>
      <a-form-model-item label="题目版本" prop="version">
        <a-input v-model="form.data.version" :max-length="35" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="题目分组">
        <a-input v-model="form.data.questionGroup" :max-length="35" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="难度系数" prop="degreeOfDifficulty">
        <a-input-number v-model="form.data.degreeOfDifficulty" type="number" :min="0" :max="10" :step="0.1" style="width: 100%" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="能力类型" required>
        <a-cascader :options="form.abilityOptions" v-model="form.abilitys" placeholder="请选择" :load-data="abilityLoadData" change-on-select @change="abilityChange" />
      </a-form-model-item>
      <a-form-model-item label="备注信息">
        <a-input v-model="form.data.remark" type="textarea" :max-length="125" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="题目解析">
        <a-input v-model="form.data.analysis" type="textarea" :max-length="500" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item v-if="[4, 5, 6].includes(form.data.questionType)" label="矩阵标题" required>
        <a-button @click="addQuestionOption(1)">添加标题</a-button>
        <a-table bordered :data-source="form.data.questionItems.filter((f) => f.itemType === 1)" :columns="matrixColumns" :pagination="false" size="small" row-key="key" style="margin-top: 12px">
          <div class="question-option" slot="name" slot-scope="text, record">
            <div v-html="text.itemTitle" @blur="optionTitleBlur($event, text)" contenteditable="true" ref="optionTitle" class="option-title"></div>
          </div>
          <template slot="score" slot-scope="text, record">
            <a-input-number v-model="text.score" :disabled="!text.isRightChoice" type="number" :min="0" :max="999" :step="1" />
          </template>
          <template slot="isRightChoice" slot-scope="text, record">
            <a-switch v-model="text.isRightChoice" @change="rightChoiceChange(text)">
              <a-icon slot="checkedChildren" type="check" />
              <a-icon slot="unCheckedChildren" type="close" />
            </a-switch>
          </template>
          <template slot="displayOrder" slot-scope="text, record">
            <a-input-number v-model="text.displayOrder" type="number" :min="0" :max="999" :step="1" />
          </template>
          <div slot="action" class="operate" slot-scope="text, record">
            <a-button type="link" @click="editQuestionOption(text)">编辑</a-button>
            <a-button type="link" danger @click="delQuestionOption(text)">删除</a-button>
          </div>
        </a-table>
      </a-form-model-item>
      <a-form-model-item v-if="![7, 8, 9].includes(form.data.questionType)" label="题目选项" required>
        <a-button @click="addQuestionOption(0)">添加选项</a-button>
        <a-table bordered :data-source="form.data.questionItems.filter((f) => f.itemType === 0)" :columns="columns" :pagination="false" size="small" row-key="key" style="margin-top: 12px">
          <div class="question-option" slot="name" slot-scope="text, record">
            <div v-html="text.itemTitle" @blur="optionTitleBlur($event, text)" contenteditable="true" class="option-title"></div>
          </div>
          <template slot="score" slot-scope="text, record">
            <a-input-number v-model="text.score" :disabled="!text.isRightChoice" type="number" :min="0" :max="999" :step="1" />
          </template>
          <template slot="displayOrder" slot-scope="text, record">
            <a-input-number v-model="text.displayOrder" type="number" :min="0" :max="999" :step="1" />
          </template>
          <template slot="isRightChoice" slot-scope="text, record">
            <a-switch v-model="text.isRightChoice" @change="rightChoiceChange(text)">
              <a-icon slot="checkedChildren" type="check" />
              <a-icon slot="unCheckedChildren" type="close" />
            </a-switch>
          </template>
          <div slot="action" class="operate" slot-scope="text, record">
            <a-button type="link" @click="editQuestionOption(text)">编辑</a-button>
            <a-button type="link" danger @click="delQuestionOption(text)">删除</a-button>
          </div>
        </a-table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 24 }" style="text-align: center">
        <a-button type="primary" @click="saveQuestion" :loading="savaBtnLoading">保存</a-button>
      </a-form-model-item>
    </a-form-model>

    <la-te-x-editor-modal v-model="laTeXEdit.visible" @ok="laTeXEditorOk" />
    <full-question-editor-modal v-model="fullQuestionEdit.visible" @ok="fullQuestionEditorOk" />
    <question-option-modal v-model="questionOption.visible" :info="questionOption.info" />
  </a-card>
</template>

<script>
import FullQuestionEditorModal from './components/fullQuestionEditorModal.vue'
import LaTeXEditorModal from './components/laTeXEditorModal.vue'
import QuestionOptionModal from './components/questionOptionModal.vue'
import WangEditor from 'wangeditor'

export default {
  name: 'QuestionSeting',
  components: { FullQuestionEditorModal, LaTeXEditorModal, QuestionOptionModal },
  data() {
    return {
      questionTypeList: [
        { title: '单选题', value: 1 },
        { title: '多选题', value: 2 },
        { title: '量表题', value: 3 },
        // { "title": "矩阵单选", "value": 4 },
        // { "title": "矩阵多选", "value": 5 },
        // { "title": "矩阵量表", "value": 6 },
        { title: '填空题', value: 7 },
        { title: '文件上传', value: 8 },
        { title: '问答题', value: 9 },
      ],
      form: {
        data: {
          id: undefined,
          questionType: undefined,
          name: ' ',
          version: '1.0.0',
          questionGroup: '',
          attachmentUrl: '',
          degreeOfDifficulty: 1,
          remark: '',
          analysis: '',
          abilityTypeId: undefined,
          firstAbilityId: undefined,
          secondAbilityId: undefined,
          questionItems: [],
        },
        rules: {
          questionType: [{ required: true, message: '请选择题目类型', trigger: 'change' }],
          version: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (value === '') {
                  callback(new Error('请填写版本'))
                } else if (!/^\d+\.\d+\.\d+$/.test(value)) {
                  callback(new Error('版本格式如：1.0.1或12.32.33'))
                } else {
                  callback()
                }
              },
              trigger: 'blur',
            },
          ],
          degreeOfDifficulty: [{ required: true, message: '请填写难度系数', trigger: 'change' }],
        },
        abilityOptions: [],
        abilitys: [],
        editor: null,
      },
      // 题目题干编辑弹窗
      laTeXEdit: {
        visible: false,
      },
      // 题目题干编辑弹窗
      fullQuestionEdit: {
        visible: false,
      },
      // 题目题干编辑弹窗
      questionOption: {
        visible: false,
        info: {},
      },
      // 保存题目按钮loading
      savaBtnLoading: false,
      columns: [
        { title: '名称', scopedSlots: { customRender: 'name' }, width: 400 },
        { title: '分值', scopedSlots: { customRender: 'score' } },
        { title: '是否正确', scopedSlots: { customRender: 'isRightChoice' } },
        { title: '排序', scopedSlots: { customRender: 'displayOrder' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
      matrixColumns: [
        { title: '名称', scopedSlots: { customRender: 'name' }, width: '60%' },
        { title: '排序', scopedSlots: { customRender: 'displayOrder' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
    }
  },
  created() {
    this.initWangEditor()
    this.getQuestionDetails()
    this.abilityTypeSelect(0)
  },
  beforeDestroy() {
    if (this.form.editor) {
      this.form.editor.destroy() // 组件销毁时，及时销毁编辑器
    }
  },
  methods: {
    questionTypeChange() {
      this.form.data.questionItems = []
    },
    optionTitleBlur(e, item) {
      item.itemTitle = e.target.innerHTML
    },
    rightChoiceChange(val) {
      if (!val.isRightChoice) {
        val.score = 0
      }
    },
    editQuestionOption(val) {
      this.questionOption.info = val
      this.questionOption.visible = true
    },
    delQuestionOption(item) {
      this.form.data.questionItems = this.form.data.questionItems.filter((f) => f.key !== item.key)
    },
    addQuestionOption(type) {
      const length = this.form.data.questionItems.filter((f) => f.itemType === type).length
      const data = {
        key: Date.now(),
        itemTitle: '',
        itemType: type,
        isRightChoice: false,
        score: 0,
        displayOrder: length + 1,
        itemAttachmentUrl: '',
      }
      if (type === 1) {
        delete data.isRightChoice
        delete data.score
      }
      this.form.data.questionItems.push(data)
      this.optionTitlePaste()
    },
    // 处理div输入框粘贴带样式行为
    optionTitlePaste() {
      this.$nextTick(() => {
        const optionTitle = document.querySelectorAll('.option-title')
        for (let i = 0; i < optionTitle.length; i++) {
          if (!optionTitle[i].onpaste) {
            optionTitle[i].onpaste = (e) => {
              // 阻止默认粘贴行为（关键，避免带样式内容直接粘贴）
              e.preventDefault()
              const clipboardData = e.clipboardData || window.clipboardData
              if (!clipboardData) return

              // 1. 处理剪贴板中的图片（保留并插入，支持截图/本地图片）
              const imageFiles = Array.from(clipboardData.files).filter((file) => file.type.startsWith('image/'))

              // 2. 处理剪贴板中的文本（剥离所有样式，仅保留纯文本）
              const plainText = clipboardData.getData('text/plain') || ''

              // 获取当前光标位置（用于精准插入内容，符合编辑习惯）
              const selection = window.getSelection()
              let insertRange = null
              if (selection.rangeCount > 0) {
                insertRange = selection.getRangeAt(0)
                insertRange.deleteContents() // 清除光标位置原有内容
              }

              // 3. 先插入纯文本（若有）
              if (plainText.trim()) {
                const textNode = document.createTextNode(plainText)
                if (insertRange) {
                  insertRange.insertNode(textNode)
                  // 光标移到文本后方，为后续插入图片做准备
                  insertRange.setStartAfter(textNode)
                  insertRange.collapse(true)
                }
              }

              if (imageFiles.length > 0) {
                imageFiles.forEach((file) => {
                  this.getFileBase64(file).then((base64) => {
                    const img = new Image()
                    img.src = base64
                    // 插入图片到当前光标位置
                    if (insertRange) {
                      insertRange.insertNode(img)
                      // 光标移到图片后方，保持编辑连贯性
                      insertRange.setStartAfter(img)
                      insertRange.collapse(true)
                    }
                  })
                })
              }

              // 恢复光标位置，提升编辑体验
              if (insertRange) {
                selection.removeAllRanges()
                selection.addRange(insertRange)
              }
            }
          }
        }
      })
    },
    // 处理火狐粘贴图片会多一根横线
    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          const img = new Image()
          img.src = reader.result
          img.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.width = img.width
            canvas.height = img.height - 1
            ctx.drawImage(img, 0, -1)
            resolve(canvas.toDataURL('image/png'))
          }
        }
      })
    },
    laTeXEditorOk(val) {
      this.form.editor.cmd.do('insertHTML', val)
    },
    fullQuestionEditorOk(val) {
      this.form.editor.cmd.do('insertHTML', val)
    },
    initWangEditor() {
      this.$nextTick(() => {
        if (!this.form.editor) {
          const that = this
          this.form.editor = new WangEditor(this.$refs.wangEditorBox)
          this.form.editor.config.height = 200
          this.form.editor.config.showFullScreen = false
          this.form.editor.config.showLinkImg = false
          // this.form.editor.config.uploadImgShowBase64 = true;
          this.form.editor.config.excludeMenus = ['video']
          // 配置alt选项
          this.form.editor.config.showLinkImgAlt = false
          this.form.editor.config.showLinkImgHref = false

          this.form.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
            this.getFileBase64(resultFiles[0]).then((base64) => {
              insertImgFn(base64)
            })
          }

          class MathJax extends WangEditor.BtnMenu {
            // 公式输入插件
            constructor(editors) {
              const $elem = WangEditor.$(`<div data-title="编写公式" class="w-e-menu"><i class="iconfont icon-shujujuzhen" style="font-size:18px;font-weight: bold;"></i></div>`)
              super($elem, editors)
            }

            // 菜单点击事件
            clickHandler() {
              that.laTeXEdit.visible = true
            }

            tryChangeActive() {}
          }

          this.form.editor.menus.extend('mathJax', MathJax)
          this.form.editor.config.menus.push('mathJax')
          this.form.editor.create()
        }
      })
    },
    // 保存题目
    saveQuestion() {
      this.form.data.name = this.form.editor.txt.html()
      if (!this.validateQuestion(this.form.data)) {
        return false
      }
      const results = this.form.data
      results.questionItems = results.questionItems.map((m1) => {
        m1.key = undefined
        // 错误项为0分
        m1.score = m1.isRightChoice ? m1.score : 0
        return m1
      })
      this.savaBtnLoading = true
      if (this.$route.query.id) {
        this.$http
          .questionsUpdate(this.form.data)
          .then((res) => {
            this.$message.success(res.message)
            this.$router.go(-1)
          })
          .finally(() => {
            this.savaBtnLoading = false
          })
        return
      }
      this.$http
        .questionsAdd([this.form.data])
        .then((res) => {
          this.$message.success(res.message)
          this.$router.go(-1)
        })
        .finally(() => {
          this.savaBtnLoading = false
        })
    },
    // 校验题目的值是否通过
    validateQuestion(item) {
      if (!item.questionType) {
        this.$message.error('请选择题目类型')
        return false
      }
      if (!item.name) {
        this.$message.error('请填写题目名称')
        return false
      }
      if (!item.version) {
        this.$message.error('请填写题目版本')
        return false
      }
      if (!item.degreeOfDifficulty) {
        this.$message.error('请填写难度系数')
        return false
      }
      if (!item.abilityTypeId) {
        this.$message.error('请选择能力类型')
        return false
      }
      if ([4, 5, 6].includes(item.questionType)) {
        if (!item.questionItems.filter((f) => f.itemType === 1).length) {
          this.$message.error('请添加矩阵标题')
          return false
        }
        if (item.questionItems.some((s) => !s.itemTitle && s.itemType === 1)) {
          this.$message.error('请填写矩阵标题')
          return false
        }
      }
      if (![7, 8, 9].includes(item.questionType)) {
        if (!item.questionItems.filter((f) => f.itemType === 0).length) {
          this.$message.error('请添加题目选项')
          return false
        }
        if (item.questionItems.some((s) => !s.itemTitle && s.itemType === 0)) {
          this.$message.error('请填写题目选项')
          return false
        }
        const itemTitleObj = {}
        item.questionItems.forEach((f) => {
          if (!Array.isArray(itemTitleObj[f.itemTitle])) {
            itemTitleObj[f.itemTitle] = [f]
            return
          }
          itemTitleObj[f.itemTitle].push(f)
        })
        for (const key in itemTitleObj) {
          if (itemTitleObj[key].length > 1) {
            this.$message.error(`选项标题重复`)
            return false
          }
        }
      }
      return true
    },
    // 题目能力类型三个事件
    abilityTypeSelect(level) {
      let params = {
        level: level,
      }
      return new Promise((resolve, reject) => {
        this.$http.abilitySelect(params).then((res) => {
          const { status, data, message } = res.data
          this.form.abilityOptions = data.map((m) => {
            return {
              ...m,
              value: m.id,
              leaf: 1,
              label: m.name,
              isLeaf: false,
            }
          })
          // 排序
          this.form.abilityOptions.sort((a, b) => {
            return a.abilityType - b.abilityType
          })
          let arr = []
          let arr2 = []
          this.form.abilityOptions.forEach((item, index) => {
            item.value = item.id
            item.label = item.name
            item.isLeaf = false
            if (item.abilityType == 0) {
              arr.push(index)
              arr.sort((a, b) => {
                return a - b
              })
            }
            if (item.abilityType == 1) {
              arr2.push(index)
              arr2.sort((a, b) => {
                return a - b
              })
            }
          })
          let str = {
            label: '通用能力',
            name: '通用能力',
            disabled: true,
            value: '通用能力',
          }
          let str2 = {
            label: '题目能力',
            name: '题目能力',
            disabled: true,
            value: '题目能力',
          }
          this.form.abilityOptions.splice(arr[0], 0, str)
          this.form.abilityOptions.splice(arr2[0] + 1, 0, str2)
          resolve(data)
        })
      })
    },
    abilityChange(value) {
      this.form.abilitys = value
      this.form.data.abilityTypeId = value[0]
      this.form.data.firstAbilityId = value[1]
      this.form.data.secondAbilityId = value[2]
    },
    abilityLoadData(selectedOptions) {
      if (!selectedOptions.length) {
        return Promise.reject()
      }
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      targetOption.children = []
      return new Promise((resolve, reject) => {
        this.$http
          .abilitySelect({
            pid: targetOption.id,
          })
          .then((res) => {
            targetOption.loading = false
            const { status, data, message } = res.data
              targetOption.children = data.map((m) => ({
                ...m,
                value: m.id,
                leaf: targetOption.leaf + 1,
                key: m.id,
                label: m.name,
                isLeaf: targetOption.leaf + 1 > 2,
              }))
              this.form.abilityOptions = [...this.form.abilityOptions]
              resolve(targetOption.children)
         
          })
      })
    },
    getQuestionDetails() {
      if (!this.$route.query.id) {
        return
      }
      this.$http.questionsDetail({ id: this.$route.query.id }).then((res) => {
        for (let dataKey in this.form.data) {
          if (typeof res.data[dataKey] !== 'undefined') {
            this.form.data[dataKey] = res.data[dataKey]
          }
        }
        this.form.data.questionItems = res.data.questionItems.map((m) => {
          // 兼容旧的 itemAttachmentUrl
          if (m.itemAttachmentUrl) {
            m.itemTitle = `<img src="${this.$filterUrl(m.itemAttachmentUrl)}">`
          }
          return {
            key: m.id,
            itemTitle: m.itemTitle,
            itemType: m.itemType,
            isRightChoice: m.isRightChoice,
            score: m.score,
            displayOrder: m.displayOrder,
            itemAttachmentUrl: '',
          }
        })
        this.form.abilitys = [res.data.abilityTypeId, res.data.firstAbilityId, res.data.secondAbilityId]
        this.form.editor.txt.html(res.data.name)
        this.abilityLoadData(this.form.abilityOptions.filter((f) => f.id === res.data.abilityTypeId)).then((load) => {
          this.abilityLoadData(load.filter((f) => f.id === res.data.firstAbilityId))
        })
        this.optionTitlePaste()
      })
    },
  },
}
</script>

<style scoped lang="less">
/deep/ .wang-editor > div {
  z-index: 2 !important;

  &:first-child {
    z-index: 3 !important;
  }
}

.question-option {
  display: flex;
  align-items: flex-start;
  line-height: 24px;

  .option-title {
    flex: 1 1;
    outline: 1px solid #d9d9d9;
    border-radius: 4px;

    &[contenteditable='true']:focus-visible {
      outline: 1px solid @primary-color;
    }

    /deep/ * {
      margin: 0;
      padding: 0;
      outline: none;
    }
  }
}
</style>
